export default __webpack_public_path__ + "static/media/mysql.1043630e.svg";